module.exports = __webpack_public_path__ + "static/media/user.cae11bfc.svg";